import { createContext, useContext } from 'react';

export const GlobalProductPageContext = createContext();
export const useGlobalProductPageContext = () =>
  useContext(GlobalProductPageContext);
